import React, { useState, useEffect } from "react";
import Badge from "react-bootstrap/Badge";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";
import axios from "axios";
import "./MarkdownComponent.css";
import Papa from "papaparse";
import { format } from "sql-formatter";
import Accordion from "react-bootstrap/Accordion";
import { faThumbsUp } from "@fortawesome/free-regular-svg-icons/faThumbsUp";
import { faThumbsDown } from "@fortawesome/free-regular-svg-icons/faThumbsDown";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  TimeScale,
  ScatterController,
} from "chart.js";
import "./CustomComponent.css";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  TimeScale,
  ScatterController,
  Title,
  Tooltip,
  Legend
);
import { Pie, Bar, Line, Scatter } from "react-chartjs-2";

const options = {
  maintainAspectRatio: true,
  legend: { display: true },
  aspectRatio: 1,
};

import { marked } from "marked";
import showdown from "showdown";
import { faChartBar, faSnowflake } from "@fortawesome/free-regular-svg-icons";
import { faSnowboarding } from "@fortawesome/free-solid-svg-icons";
showdown.setOption("tables", true);
showdown.setFlavor("github");

export const MarkdownComponent = (props) => {
  const [modifiedChartOptions, setModifiedChartOptions] = useState();
  const [messageLikes, setMessageLikes] = useState();
  const [messageDislikes, setMessageDislikes] = useState();
  const [htmlSteps, setHtmlSteps] = useState([]);
  const [isStreamComplete, setIsStreamComplete] = useState(true);

  // props.setSQLDataContent(props.sqlQuery);

  function onClickMessageFeedback(likes, dislikes) {
    if (likes == 1 && messageLikes == 1) {
      setMessageLikes(0);
      setMessageDislikes(0);
      likes = 0;
    } else if (dislikes == 1 && messageDislikes == 1) {
      setMessageLikes(0);
      setMessageDislikes(0);
      dislikes = 0;
    } else if (likes > 0) {
      setMessageLikes(1);
      setMessageDislikes(0);
    } else if (dislikes > 0) {
      setMessageDislikes(1);
      setMessageLikes(0);
    }
    try {
      axios
        .post(process.env.REACT_APP_API_DOMAIN + "/message_feedback", {
          email: props.profile.email,
          message_id: props.message_id,
          likes: likes,
          dislikes: dislikes,
        })
        .then((response) => {
          // let formatResponse = Papa.parse(response.data.response, {
          //   header: true,
          //   skipEmptyLines: true,
          // });
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  }

  function onClickRawData() {
    props.setShowDataModal(true);
    props.setIsDataReady(false);
    props.setDataModalContent([]);

    let propsData = props.data;

    if (typeof propsData === "string") {
      propsData = JSON.parse(props.data);
    }

    try {
      axios
        .post(process.env.REACT_APP_API_DOMAIN + "/makeCSV", {
          data: propsData,
        })
        .then((response) => {
          let formatResponse = Papa.parse(response.data.response, {
            header: true,
            skipEmptyLines: true,
          });

          props.setDataModalContent(formatResponse.data);
          props.setShowDataModal(true);
          props.setIsDataReady(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
  }
  function onClickSQL(evt) {
    props.setShowSQLData(true);

    //format('SELECT * FROM tbl', { language: 'mysql' })
    props.setSQLDataContent(format(props.sqlQuery, { language: "snowflake" }));
    console.log(format(props.sqlQuery, { language: "snowflake" }));
  }

  function onClickRetry(content) {
    var new_convo = {};
    new_convo["company"] = props.partnerMetadata.partner_name;
    new_convo["conversation_name"] = content;
    new_convo["country"] = props.partnerMetadata.countries[0];
    new_convo["time"] = new Date();
    new_convo["history"] = [
      {
        message: content,
        sentTime: "just now",
        sender: props.profile.name,
        direction: "outgoing",
        country: props.partnerMetadata.countries[0],
      },
    ];
    new_convo["portco"] = props.partnerMetadata.partner_name;
    new_convo["partner_id"] = props.partnerMetadata.partner_id;

    new_convo.is_retry = true;

    localStorage.setItem("selectedReport_v2", JSON.stringify(new_convo));

    props.onSelectReport(new_convo);
  }

  function onClickMonitor(evt) {
    props.setShowMonitorModal(true);
    props.setMonitorReady(false);
    props.setMonitorContent(
      "Our Monitoring Agent is coming up with a plan. Give it a few seconds...."
    );
    try {
      axios
        .post(process.env.REACT_APP_API_DOMAIN + "/startMonitor", {
          analysis: props.content,
          data: props.data,
          partner_id: props.partner_id,
        })
        .then((response) => {
          let formatResponse = marked.parse(response.data.response);
          props.setMonitorContent(formatResponse);
          props.setMonitorReady(true);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.error("Error processing message:", error);
    } finally {
    }
    //
  }

  // options: {
  //       plugins: {
  //           title: {
  //               display: true,
  //               text: 'TEST'
  //           }
  //       }
  //   }

  const [html, setHtml] = useState("");

  useEffect(() => {
    if (props.feedback) {
      setMessageDislikes(props.feedback.dislikes);
      setMessageLikes(props.feedback.likes);
    }
    if (props.chart && props.chart.options != undefined) {
      let new_chart = props.chart.options;

      let total_in_dataset = props.chart.data.datasets.length;

      let modified_leged = {};
      modified_leged["maxWidth"] = 10000000000;
      modified_leged["display"] = true;

      if (total_in_dataset == 1) {
        modified_leged["position"] = "top";
      } else {
        modified_leged["position"] = "left";
      }

      if (new_chart.plugins != undefined) {
        new_chart.plugins.legend = modified_leged;
      } else {
        new_chart.plugins = {};
        new_chart.plugins.legend = modified_leged;
      }

      setModifiedChartOptions(new_chart);
    }
  }, [props.chart, isStreamComplete]);
  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
  async function setContent(reader) {
    var receivedData = "";
    var allData = "";
    props.setIsStreaming(true);
    setIsStreamComplete(false);
    if (reader != undefined) {
      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          props.setStreamMessage(allData);
          setIsStreamComplete(true);
          break;
        }
        // Process the received chunk (value is a Uint8Array)
        const chunkString = new TextDecoder().decode(value);
        allData += chunkString;
        // if (chunkString.includes("$*END*$")) {
        //   break;
        // }
        receivedData += chunkString;
        // receivedData = receivedData.split("$*END*$")[0];

        if (!receivedData.includes("$*END*$")) {
          const marked_version = marked.parse(receivedData);
          setHtml(marked_version);
          await delay(100);
        } else {
          props.setIsStreaming(false);
        }
      }
    }
  }

  useEffect(() => {
    if (props.reader) {
      setContent(props.reader);
    } else {
      const marked_version = marked.parse(props.content);
      setHtml(marked_version);
    }
  }, [props.content]);

  const [table, setTable] = useState(props.table);

  function convertToMarkdownTable(queryResults) {
    if (!queryResults || queryResults.length === 0) {
      return "";
    }

    const headers = Object.keys(queryResults[0]);
    const rows = queryResults.map((row) =>
      headers.map((header) => row[header])
    );

    let markdownTable = `| ${headers.join(" | ")} |\n`;
    markdownTable += `| ${headers.map(() => "---").join(" | ")} |\n`;
    markdownTable += rows.map((row) => `| ${row.join(" | ")} |`).join("\n");

    return markdownTable;
  }

  const dataToTable = (dataset, options) => {
    let html = "<table>";

    if (
      options != undefined &&
      options.scales &&
      options.scales.x != undefined
    ) {
      html += `<thead><tr><th style="width:120px;">${options.scales.x.title.text}</th>`;
    } else if (
      options != undefined &&
      options.scales &&
      options.scales.xAxes != undefined
    ) {
      html += `<thead><tr><th style="width:120px;">${options.scales.xAxes[0].scaleLabel.labelString}</th>`;
    } else {
      html += `<thead><tr><th style="width:120px;">#</th>`;
    }
    // html += `<thead><tr><th style="width:120px;">#</th>`;

    let columnCount = 0;
    let columnTotals = [];

    dataset.datasets.forEach((item, i) => {
      html += `<th style="background-color:${item.fillColor};">${item.label}</th>`;
      columnCount += 1;
      columnTotals[i] = 0; // Initialize totals
    });

    html += "</tr></thead><tbody>";

    dataset.labels.forEach((item, idx) => {
      html += `<tr><td>${item}</td>`;
      for (let i = 0; i < columnCount; i++) {
        let cellData = dataset.datasets[i].data[idx];

        // Handle null values
        if (cellData === null || cellData == undefined) {
          cellData = "";
        } else if (!isNaN(cellData) && cellData !== "") {
          // Convert to number and round
          cellData = parseFloat(cellData);
          columnTotals[i] += cellData; // Add to total
          cellData = cellData.toFixed(2);
        }

        // Replace '0.00' with '-'
        if (cellData === "0.00") {
          cellData = "-";
        }

        html += `<td style="background-color:${dataset.datasets[i].fillColor};">${cellData}</td>`;
      }
      html += "</tr>";
    });

    // Add total row
    // html += "<tr><td><strong>Total</strong></td>";
    // for (let i = 0; i < columnCount; i++) {
    //   let totalValue = columnTotals[i] === 0 ? "-" : columnTotals[i].toFixed(2);
    //   html += `<td style="background-color:${dataset.datasets[i].fillColor};"><strong>${totalValue}</strong></td>`;
    // }
    // html += "</tr>";

    html += "</tbody></table>";

    return html;
  };

  function makeVintageTable(queryResults) {}

  useEffect(() => {
    const converter = new showdown.Converter();

    var convertedHtml = "";
    var merged_array = [];
    if (props.chart != undefined && props.chart.data != undefined) {
      // let fields = props.data.fields;

      // let rows = props.data.rows;

      let chart_data = props.chart.data;
      let chart_options = props.chart.options;

      //.concat(rows);
      merged_array = dataToTable(chart_data, chart_options);
      convertedHtml = merged_array;
    }

    let markdown_table = convertedHtml;

    setTable(markdown_table);
  }, [props]);
  return (
    <div>
      {props.direction === "incoming" ? (
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: html,
            }}
          ></div>
          {props.chart != null && props.chart.data != null ? (
            <div>
              <div className="custom_container">
                {props.chart.type == "pie" ? (
                  <Pie data={props.chart.data} options={modifiedChartOptions} />
                ) : props.chart.type == "line" ? (
                  <Line
                    data={props.chart.data}
                    options={modifiedChartOptions}
                  />
                ) : props.chart.type == "scatter" ? (
                  <Scatter
                    data={props.chart.data}
                    options={modifiedChartOptions}
                  />
                ) : (
                  <Bar data={props.chart.data} options={modifiedChartOptions} />
                )}
              </div>

              <p>&nbsp;</p>

              <Accordion className="tableAccordion">
                <Accordion.Item eventKey={Math.random().toString()}>
                  <Accordion.Header className="dataAccordionHeader">
                    Data Table
                  </Accordion.Header>
                  <Accordion.Body className="dataAccordionBody">
                    <div>
                      <div
                        className="tableDiv"
                        dangerouslySetInnerHTML={{
                          __html: table,
                        }}
                      ></div>
                      {/* <Button onClick={onClickRawData} variant="link">
                        <Badge bg="secondary">📊 All Data</Badge>
                      </Button>
                      <Button onClick={onClickSQL} variant="link">
                        <Badge bg="secondary">🛢 SQL</Badge>
                      </Button> */}
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          ) : (
            <div
              className="tableDiv"
              dangerouslySetInnerHTML={{
                __html: table,
              }}
            ></div>
          )}

          {/* 
          {props.chart && props.chart.data ? (
            <div className="monitorBar">
              <Stack direction="horizontal" gap={0}>
                <Button onClick={onClickMonitor} variant="link">
                  <Badge bg="warning" text="dark">
                    🕵️‍♂️ Monitor
                  </Badge>
                </Button>

                <Button onClick={onClickRawData} variant="link">
                  <Badge bg="secondary">📊 CSV</Badge>
                </Button>
                {props.sqlQuery != undefined ? (
                  <Button onClick={onClickSQL} variant="link">
                    <Badge bg="secondary">🛢 SQL</Badge>
                  </Button>
                ) : (
                  <div></div>
                )}
              </Stack>
            </div>
          ) : (
            <div className="monitorBar">
              {props.data != undefined && props.data != "" ? (
                <div>
                  <Stack direction="horizontal" gap={0}>
                    <Button onClick={onClickRawData} variant="link">
                      <Badge bg="secondary">📊 CSV</Badge>
                    </Button>

                    <Button onClick={onClickSQL} variant="link">
                      <Badge bg="secondary">🛢 SQL</Badge>
                    </Button>
                  </Stack>
                </div>
              ) : (
                <div></div>
              )}
            </div>
          )} */}
        </div>
      ) : (
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: marked.parse(props.content),
            }}
          ></div>
          {/* <Button onClick={() => onClickRetry(props.content)} variant="link">
            🔄
          </Button> */}
        </div>
      )}
      {props.direction == "incoming" && isStreamComplete == true ? (
        <div className="message_option_section">
          <Stack direction="horizontal" gap={11111}>
            <div>
              <Button onClick={onClickSQL} variant="link">
                <FontAwesomeIcon
                  className="message_options"
                  icon={faSnowflake}
                  size="lg"
                />
              </Button>
            </div>

            <div>
              <Button onClick={onClickRawData} variant="link">
                <FontAwesomeIcon
                  className="message_options"
                  icon={faChartBar}
                  size="lg"
                />
              </Button>
            </div>

            <div>
              <Button
                onClick={() => onClickMessageFeedback(1, 0)}
                variant="link"
              >
                {messageLikes > 0 ? (
                  <FontAwesomeIcon
                    className="message_options_active"
                    icon={faThumbsUp}
                    size="lg"
                  />
                ) : (
                  <FontAwesomeIcon
                    className="message_options"
                    icon={faThumbsUp}
                    size="lg"
                  />
                )}
              </Button>
            </div>

            <div>
              <Button
                onClick={() => onClickMessageFeedback(0, 1)}
                variant="link"
              >
                {messageDislikes > 0 ? (
                  <FontAwesomeIcon
                    className="message_options_active"
                    icon={faThumbsDown}
                    size="lg"
                  />
                ) : (
                  <FontAwesomeIcon
                    className="message_options"
                    icon={faThumbsDown}
                    size="lg"
                  />
                )}
              </Button>
            </div>
          </Stack>
        </div>
      ) : (
        <div className="message_option_section"></div>
      )}
    </div>
  );
};
export default MarkdownComponent;
